__turbopack_context__.v({
  "className": "inter_tight_1fbaee3e-module__wZX_Ga__className",
  "variable": "inter_tight_1fbaee3e-module__wZX_Ga__variable",
});
